// extracted by mini-css-extract-plugin
module.exports = {"openCloseMenu":"_10xSp","buttonLabel":"_1LgUp","opened":"_2-M3m"};